import { Center, useColorMode } from "@chakra-ui/react";
import Link from "next/link";

export default function DiscoverButton() {
  const { colorMode } = useColorMode();

  const buttonText = colorMode === "light" ? "text-black" : "text-white";
  const buttonBG = colorMode === "light" ? "bg-white" : "bg-black";

  return (
    <Center mb={10}>
      <Link href="/">
        <button className="mt-7 mb-5 rounded-2xl p-px bg-[linear-gradient(to_right,rgba(255,153,213,0.9),rgba(255,102,196,0.9),rgba(255,102,196,0.9),rgba(255,102,196,0.9),rgba(255,153,213,0.9))] bg-[length:400%_auto] animate-gradient">
          {" "}
          <div
            className={`rounded-2xl p-3 w-100 ${buttonBG} font-semibold ${buttonText}`}
          >
            Browse Songcards
          </div>
        </button>
      </Link>
    </Center>
  );
}
